import { render, staticRenderFns } from "./viewUser.vue?vue&type=template&id=7b95584e&"
import script from "./viewUser.vue?vue&type=script&lang=js&"
export * from "./viewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports